// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { DealerFormGroup } from '@interfaces/create-deal-inputs.interface';
import { DealsService } from '@services/deals.service';
import { UserService } from '@services/user.service';
import { takeWhile } from 'rxjs/operators';

@Component({
    selector: 'app-dealer-form',
    templateUrl: './dealer-form.component.html',
})
export class DealerFormComponent implements OnInit, OnDestroy {
    @Input() dealerFormProperties: DealerFormGroup;
    @Output() attachForm = new EventEmitter<FormGroup>();
    @Input() disabledInputs: string[];
    private isComponentAlive = true;
    dealerDealNumber: string;
    dealerForm: FormGroup;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly dealsService: DealsService,
        private readonly dialog: MatDialog,
        private fb: FormBuilder,
        private readonly router: Router,
        private readonly userService: UserService
    ) {
        this.buildForm();
    }

    ngOnInit(): void {
        if (this.dealerFormProperties) {
            this.setFormValues();
        }

        this.formChanges();
    }

    formChanges(): void {
        this.dealerForm.valueChanges.pipe(takeWhile(() => this.isComponentAlive)).subscribe((value) => {
            this.attachForm.emit(value);
        });
    }

    buildForm() {
        this.dealerForm = this.fb.group({
            dealerDealNumber: new FormControl(''),
        });
    }

    setFormValues(): void {
        this.dealerForm.setValue({
            dealerDealNumber: this.dealerFormProperties.dealerDealNumber ? this.dealerFormProperties.dealerDealNumber : '',
        });

        this.disabledInputs.forEach((input) => {
            this.dealerForm.get(input).disable();
        });
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
